export default 'M1 5a4 4 0 0 1 4-4h14a4 4 0 0 1 4 4v14a4 4 0 0 1-4 4H5a4 4 0 0 1-4-4zm9.5 5.5H6v3h4.5V18h3v-4.5H18v-3h-4.5V6h-3z';